import { render, staticRenderFns } from "./ManageZoneMaintenancePage.vue?vue&type=template&id=88b97f22"
import script from "./ManageZoneMaintenancePage.vue?vue&type=script&lang=js"
export * from "./ManageZoneMaintenancePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports